import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { VENUES_ACTIONS, VENUES_TYPES } from "./actions";
import {
  getVenue as APIgetVenue,
  getVenues as APIgetVenues,
  createVenue as APIcreateVenue,
  updateVenue as APIupdateVenue,
  deleteVenue as APIdeleteVenue
} from "../../services/api/venues";
import { createNavigateTo, navigateTo } from "../navigation/saga";
import { venuesFilters } from "./selectors";

export function* watchVenuesActions() {
  yield all([takeEvery(VENUES_TYPES.LOAD_ALL_REQUEST, getVenues)]);
  yield all([takeEvery(VENUES_TYPES.LOAD_REQUEST, getVenue)]);
  yield all([takeEvery(VENUES_TYPES.CREATE_REQUEST, createVenue)]);
  yield all([takeEvery(VENUES_TYPES.UPDATE_REQUEST, updateVenue)]);
  yield all([takeEvery(VENUES_TYPES.DELETE_REQUEST, deleteVenue)]);
  yield all([
    takeEvery(VENUES_TYPES.UPDATE_SUCCESS, createNavigateTo("/admin/venues"))
  ]);
  yield all([takeEvery(VENUES_TYPES.CREATE_SUCCESS, getVenues)]);
  yield all([takeEvery(VENUES_TYPES.DELETE_SUCCESS, getVenues)]);
  yield all([takeEvery(VENUES_TYPES.UPDATE_FILTERS, getVenues)]);
}

function* getVenues(action) {
  try {
    const filters = yield select(venuesFilters);
    const venues = yield call(APIgetVenues, filters);
    yield put(VENUES_ACTIONS.loadAllSuccess(venues));
  } catch (e) {
    yield put(VENUES_ACTIONS.loadAllFailure(e));
  }
}

function* getVenue(action) {
  const { id } = action.payload;
  try {
    const venue = yield call(APIgetVenue, id);
    yield put(VENUES_ACTIONS.loadSuccess(venue));
  } catch (e) {
    yield put(VENUES_ACTIONS.loadFailure(e));
  }
}

function* createVenue(action) {
  const { values, redirect } = action.payload;
  try {
    const venue = yield call(APIcreateVenue, values);
    yield put(VENUES_ACTIONS.createSuccess(venue));

    if (redirect) {
      yield call(navigateTo, "/admin/zones/create?venue=" + venue.id);
    }
  } catch (e) {
    yield put(VENUES_ACTIONS.createFailure(e));
  }
}

function* updateVenue(action) {
  const { id, values } = action.payload;
  try {
    const venue = yield call(APIupdateVenue, id, values);
    yield put(VENUES_ACTIONS.updateSuccess(venue));
  } catch (e) {
    yield put(VENUES_ACTIONS.updateFailure(e));
  }
}

function* deleteVenue(action) {
  const { id } = action.payload;
  try {
    const venue = yield call(APIdeleteVenue, id);
    yield put(VENUES_ACTIONS.deleteSuccess(venue));
  } catch (e) {
    yield put(VENUES_ACTIONS.deleteFailure(e));
  }
}
